import { getStore } from '../store/SharePointItemsViewNavigationLocationStore';
import { mutatorAction } from 'satcheljs';
import transformGroupSmtp from 'owa-group-common/lib/utils/transformGroupSmtp';

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setSharePointItemsViewNavigationPath: (
    groupSmtpAddress: string,
    path: string
) => void = mutatorAction(
    'setSharePointItemsViewNavigationPath',
    (groupSmtpAddress: string, path: string): void => {
        const store = getStore();
        groupSmtpAddress = transformGroupSmtp(groupSmtpAddress);
        if (store.has(groupSmtpAddress)) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (13,13): Object is possibly 'undefined'.
            // @ts-expect-error
            store.get(groupSmtpAddress).currentPath = path;
        } else {
            store.set(groupSmtpAddress, {
                currentPath: path,
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (20,17): Type 'undefined' is not assignable to type 'string'.
                // @ts-expect-error
                targetPath: undefined,
            });
        }
    }
);

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setSharePointItemsViewNavigationTargetPath: (
    groupSmtpAddress: string,
    path: string
) => void = mutatorAction(
    'setSharePointItemsViewNavigationTargetPath',
    (groupSmtpAddress: string, path: string): void => {
        const store = getStore();
        groupSmtpAddress = transformGroupSmtp(groupSmtpAddress);
        if (store.has(groupSmtpAddress)) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (35,13): Object is possibly 'undefined'.
            // @ts-expect-error
            store.get(groupSmtpAddress).targetPath = path;
        } else {
            store.set(groupSmtpAddress, {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (41,17): Type 'undefined' is not assignable to type 'string'.
                // @ts-expect-error
                currentPath: undefined,
                targetPath: path,
            });
        }
    }
);
